import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, ApprovalRolesDialogueHandler } from './types';
import ApprovalRolesDialogueContext from './ApprovalRolesContext';

const { ConfirmationDialogue } = vp;

type ApprovalRolesDialogueProps = {
  handleDialogue: DialogueHandler<ApprovalRolesDialogueHandler>;
};

type FC = FunctionComponent<ApprovalRolesDialogueProps>;

const ApprovalRolesDialogue: FC = ({ handleDialogue }: ApprovalRolesDialogueProps) => {
  const { approvalRolesError, showApprovalRolesErrorAlert, showApprovalRolesSuccess } =
    useContext(ApprovalRolesDialogueContext);

  return useMemo(
    () => (
      <div>
        {/* Approval Roles Error */}
        <ConfirmationDialogue
          isVisible={showApprovalRolesErrorAlert}
          title="Error! The roles was not updated."
          status="error"
          subTitle={`${approvalRolesError}`}
          confirm={{
            label: 'Back',
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />
        {/* Approval Roles Success */}
        <ConfirmationDialogue
          buttonWidth="100%"
          isVisible={showApprovalRolesSuccess}
          title="Success! The roles were updated."
          status="success"
          subTitle="Navigate back to roles."
          confirm={{
            label: 'Back to Roles',
            action: () => handleDialogue({ type: 'success', state: 'confirm' }),
          }}
        />
      </div>
    ),
    [showApprovalRolesSuccess, approvalRolesError, showApprovalRolesErrorAlert],
  );
};

export default ApprovalRolesDialogue;
